module.exports = __webpack_public_path__ + "media/svg-new/svg-lock-b1523a05.svg";